<template>
  <b-container class="bv-example-row" id="orders" fluid>
    <b-row>
      <b-col>
        <h1>OrderMonitor</h1>
      </b-col>
    </b-row>
    <hr />
      <transition name="fade">
      <b-row v-if="orders.length > 0">
        <b-button variant="info">終了</b-button>
        <b-card class="text-center" v-for="(item, index) in orders" :key="index">
          テーブル：{{ item.tableNo }} | 開始時間：{{ item.createdAt }} |  状態：{{ item.status }}
          <b-card v-for="(detail, idx) in item.details" :key="idx">
            {{ detail.menuName}}
          </b-card>
        </b-card>
      </b-row>
    </transition>
  
    <hr />
  </b-container>
</template>

<script>
import { API } from "aws-amplify";
// import { createOrder } from "../graphql/mutations";
import { onCreateOrder, onCreateOrderDetail } from "../graphql/subscriptions";
// import { OrderStatus } from "./models";

// // to disable Analytics
// Analytics.disable();

// // to enable Analytics
// Analytics.enable();

export default {
  name: "OrderMonitor",
  async created() {
    this.subscribe();
  },
  data() {
    return {
      orders: [],
      ordersDelivered: [],
    };
  },
  methods: {
    subscribe() {
      API.graphql({ query: onCreateOrder }).subscribe({
        next: eventData => {
          console.log("onCreateOrder:", eventData);
          let order = eventData.value.data.onCreateOrder;
          order["details"] = [];
          this.orders.push(order);
       }
      });

      API.graphql({ query: onCreateOrderDetail }).subscribe({
        next: eventData => {
          console.log("onCreateOrderDetail:", eventData);
          let orderDetail = eventData.value.data.onCreateOrderDetail;

          this.orders.filter(order => order.id == orderDetail.orderId).forEach(
            order => order["details"].push(orderDetail)
          );
          //this.ordersDelivered.push(orderDetail);
          //let orderDetail = eventData.value.data.onCreateOrderDetail;
       }
      });

    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>